module.exports = __webpack_public_path__ + "static/media/phone.7a2166b8.svg";